import { Box, Grid, Typography } from '@mui/material'
import { FC } from 'react'
import { useGetList, useTranslate } from 'react-admin'
import { CertificateOut, AuditLogOut } from '../../types/apiRequests'
import { dateFormatter } from '../../utils/dateFormatter'

interface Props {
  record: CertificateOut | undefined;
}

const CertificateLogs: FC<Props> = ({ record }) => {
  const translate = useTranslate()

  if (!record) return <></>

  const {
    data: logs,
    isLoading,
    error,
  } = useGetList<AuditLogOut>('auditlog', {
    // eslint-disable-next-line camelcase
    filter: { certificate_id: record.id },
    pagination: { page: 1, perPage: 50 },
    sort: { field: 'created', order: 'DESC' },
  })

  return (
    <Grid item sm={12}>
      <Box>
        <Typography variant="subtitle1" sx={{ mb: '10px', mt: '20px' }}>
          <span>{translate('data.log')}</span>:<br/>
        </Typography>

        {isLoading && (
          <Typography variant="body2">
            {translate('ra.navigation.loading')}
          </Typography>
        )}

        {error && !isLoading && (
          <Typography variant="body2" color="error">
            {translate('ra.notification.http_error')}
          </Typography>
        )}

        {!isLoading && !error && (!logs || logs.length === 0) && (
          <Typography variant="body2">
            {translate('resources.audit_log.empty', { _: 'Geen logregels gevonden.' })}
          </Typography>
        )}

        {!isLoading && !error && logs?.map(log => (
          <Typography
            key={log.id}
            variant="body1"
            sx={{
              borderRadius: '10px',
              padding: '20px 10px',
              backgroundColor: '#f5f5f5',
              mb: '10px',
            }}
          >
            {dateFormatter(log.created)}:{' '}
            {log.description}
            {log.user && (
              <>
                {' '}
                ({log.user})
              </>
            )}
          </Typography>
        ))}
      </Box>
    </Grid>
  )
}

export default CertificateLogs
